import { takeLatest, put } from "redux-saga/effects";
import {
  getAllSuperAdminTransactionsStart,
  getAllSuperAdminTransactionsSuccess,
  getAllSuperAdminTransactionsFailure,
  getSuperAdminCasinoTransactionsStart,
  getSuperAdminCasinoTransactionsSuccess,
  getSuperAdminCasinoTransactionsFailure,
  getSuperAdminSportsTransactionsSuccess,
  getSuperAdminSportsTransactionsFailure,
  getSuperAdminSportsTransactionsStart,
  getHostRefferalDetailsStart,
  getHostRefferalDetailSuccess,
  getHostRefferalDetailsFailuire,
  getBankingTransactionsSuccess,
  getBankingTransactionsFailure,
  getBankingTransactionsStart,
  updateTransactionStatusSuccess,
  updateTransactionStatusFailure,
  updateTransactionStatusStart,
  getSuperAdminSportsBookTransactionsStart,
  getSuperAdminSportsBookTransactionsSuccess,
  getSuperAdminSportsBookTransactionsFailure,

  updateCryptoTransactionStatusStart,
  updateCryptoTransactionStatusSuccess,
  updateCryptoTransactionStatusFailure



} from "../redux-slices/superAdminTransactions";
import {
  getAllSuperAdminTransactions,
  getBankingTransactions,
  getRefferedUsers,
  getSuperAdminCasinoTransactions,
  getSuperAdminSportsBookTransactions,
  getSuperAdminSportsTransactions,
  updateTransactionStatus,
  updateCryptoTransactionStatus
} from "../../utils/apiCalls";
import { toast } from "../../components/Toast";
import { act } from "react";

export default function* SuperAdminTransactionsWatcher() {
  yield takeLatest(getHostRefferalDetailsStart.type, getRefferdUsersWorker);
  yield takeLatest(
    getAllSuperAdminTransactionsStart.type,
    getAllSuperAdminTransactionsWorker
  );
  yield takeLatest(
    getSuperAdminCasinoTransactionsStart.type,
    getSuperAdminCasinoTransactionsWorker
  );

  yield takeLatest(
    getSuperAdminSportsBookTransactionsStart.type,
    getSuperAdminSportsBookTransactionsWorker
  );


  yield takeLatest(
    getSuperAdminSportsTransactionsStart.type,
    getSuperAdminSportsTransactionsWorker
  );
  yield takeLatest(
    getBankingTransactionsStart.type,
    getBankingTransactionsWorker
  );
  yield takeLatest(
    updateTransactionStatusStart.type,
    updateTransactionStatusWorker
  );
  
  yield takeLatest(
    updateCryptoTransactionStatusStart.type,
    updateCryptoTransactionStatusWorker
  );

}

function* getAllSuperAdminTransactionsWorker(action) {
  try {
    const {
      limit,
      pageNo,
      search,
      startDate,
      endDate,
      currencyId,
      transactionType,
      tenantId,
      adminId,
      paymentProvider,
      isUserDetail,
      userId,
      status,
    } = action && action.payload;

    const { data } = yield getAllSuperAdminTransactions({
      limit,
      pageNo,
      search,
      startDate,
      endDate,
      currencyId,
      transactionType,
      tenantId,
      adminId,
      paymentProvider,
      isUserDetail,
      userId,
      status,
    });

    yield put(
      getAllSuperAdminTransactionsSuccess(data?.data?.transactionDetail)
    );
  } catch (e) {
    yield put(getAllSuperAdminTransactionsFailure());

    yield toast(e?.response?.data?.errors[0].description, "error");
  }
}

function* getBankingTransactionsWorker(action) {
  try {
    const {
      limit,
      pageNo,
      searchString,
      startDate,
      endDate,
      status,
      paymentMethod,
      transactionType,
    } = action && action.payload;
    const { data: { data: { data: { pagination: { total }, result } } } } = yield getBankingTransactions({
      limit,
      pageNo,
      searchString,
      startDate,
      endDate,
      status,
      paymentMethod,
      transactionType,
    });

    yield put(
      getBankingTransactionsSuccess({
        rows: result,
        count: total,
      })
    );
  } catch (e) {
    console.error("Error in getBankingTransactionsWorker:", e);
    yield put(getBankingTransactionsFailure());

    yield toast(e?.response?.data?.errors[0]?.description, "error");
  }
}

function* updateTransactionStatusWorker(action) {
  const { transactionId, actioneeEmail, status, amount, agentId, onSuccess, onError } =
    action && action.payload;
  try {
    const response = yield updateTransactionStatus({
      transactionId,
      actioneeEmail,
      status,
      amount,
      agentId,
    });
    yield put(updateTransactionStatusSuccess());

    if (response?.data?.data?.result?.success) {
      yield toast(
        response.data.data.result.message ||
          "Record updated successfully",
        "success"
      );

      if (onSuccess) onSuccess();
    }
  } catch (e) {
    yield put(
      updateTransactionStatusFailure(
        e?.response?.data?.errors?.[0]?.description
      )
    );
    yield toast(
      e?.response?.data?.errors?.[0]?.description ||
        "Failed to update transaction",
      "error"
    );

    if (onError) onError();
  }
}


// crypto transaction status update
function* updateCryptoTransactionStatusWorker(action) {
  const { id, onSuccess, onError } =
    action && action.payload;
  try {
    const response = yield updateCryptoTransactionStatus({
      id: id
    });

    yield put(updateCryptoTransactionStatusSuccess());
    if (response?.data?.data?.successful) {
      if (onSuccess) {
        yield toast(response?.data?.data?.messages || "Transaction status successfully updated", "success");
        onSuccess()
      };
    }
    else {
      yield put(
        updateCryptoTransactionStatusFailure(response?.data?.errors[0]?.description || "Transaction status failed to update")
      );
      yield toast(response?.data?.errors[0]?.description || "Transaction status failed to update", "error");

      if (onError) onError();
    }

  } catch (e) {
    console.error('Error updating transaction status:', e);
    yield put(
      updateCryptoTransactionStatusFailure(e?.response?.data?.errors[0]?.description)
    );
    yield toast(e?.response?.data?.errors[0]?.description, "error");

    if (onError) onError();
  }
}


function* getRefferdUsersWorker(action) {
  const { limit, pageNo, userId } = action && action.payload;
  console.log(limit, pageNo, userId);
  try {
    const { data } = yield getRefferedUsers({ limit, pageNo, userId });
    console.log(data?.data?.referredUsers);

    yield put(getHostRefferalDetailSuccess(data?.data?.referredUsers));
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, "error");

    yield put(
      getHostRefferalDetailsFailuire(e?.response?.data?.errors[0]?.description)
    );
  }
}

function* getSuperAdminSportsTransactionsWorker(action) {
  try {
    const {
      status,
      email,
      limit,
      pageNo,
      startDate,
      endDate,
      currencyCode,
      transactionType,
      tenantId,
      adminId,
      userId,
    } = action && action.payload;

    const { data } = yield getSuperAdminSportsTransactions({
      limit,
      pageNo,
      startDate,
      endDate,
      currencyCode,
      transactionType,
      tenantId,
      status,
      email,
      adminId,
      userId,
    });

    yield put(
      getSuperAdminSportsTransactionsSuccess(data?.data?.transactionDetail)
    );
  } catch (e) {
    yield put(getSuperAdminSportsTransactionsFailure());

    yield toast(e?.response?.data?.errors[0].description, "error");
  }
}

function* getSuperAdminCasinoTransactionsWorker(action) {
  try {
    const {
      status,
      email,
      limit,
      pageNo,
      startDate,
      endDate,
      currencyCode,
      transactionType,
      tenantId,
      adminId,
      userId,
      gameIdentifier
    } = action && action.payload;

    const { data } = yield getSuperAdminCasinoTransactions({
      limit,
      pageNo,
      startDate,
      endDate,
      currencyCode,
      transactionType,
      tenantId,
      status,
      email,
      adminId,
      userId,
      gameIdentifier
    });

    yield put(
      getSuperAdminCasinoTransactionsSuccess(data?.data?.transactionDetail)
    );
  } catch (e) {
    yield put(getSuperAdminCasinoTransactionsFailure());

    yield toast(e?.response?.data?.errors[0].description, "error");
  }
}


// sports book transactions
function* getSuperAdminSportsBookTransactionsWorker(action) {
  try {
    const {
      status,
      email,
      limit,
      pageNo,
      startDate,
      endDate,
      currencyCode,
      transactionType,
      tenantId,
      adminId,
      userId,
      betslipStatus,
      eventSearch
    } = action && action.payload;
console.log(action.payload,"payload")
    const { data } = yield getSuperAdminSportsBookTransactions({
      limit,
      pageNo,
      startDate,
      endDate,
      currencyCode,
      transactionType,
      tenantId,
      status,
      email,
      adminId,
      userId,
      betslipStatus:  betslipStatus,
      eventSearch
    });
console.log({data} , "datadatadata")
    yield put(
      getSuperAdminSportsBookTransactionsSuccess(data?.data?.transactionDetail)
    );
  } catch (e) {
    yield put(getSuperAdminSportsBookTransactionsFailure());

    yield toast(e?.response?.data?.errors[0].description, "error");
  }
}
